<template>
    <div
        class="header-nav mobile-nav-bg"
        :class="{ bg_scroll: scrolldata > 30 }"
    >
        <b-navbar class="navbar navbar-container-first mx-auto">
            <b-navbar-brand class="brand-one d-inline-block w-100-mobile-only">
                <div class="mobile-img__container">
                    <a href="https://stronghold.thetanuts.finance/">
                        <div class="mobile-img__wrapper">
                            <img
                                src="/images/landing-page/logo-thetanuts-2.svg"
                            />
                        </div>
                    </a>
                </div>
                <div
                    class="nav-item-burger-icon"
                    @click="isMenuActive = !isMenuActive"
                >
                    <img :src="iconMenu" alt="" id="menu-buger-icon" />
                </div>
                <div class="mobile-content mobile-content--hide">
                    <a
                        href="https://stronghold.thetanuts.finance/"
                        target="_blank"
                    >
                        <div class="mobile-content__text-container">
                            <span class="mobile-content__text">
                                Thetanuts Stronghold
                            </span>
                        </div>
                    </a>

                    <router-link :to="{ name: 'vault' }">
                        <div class="mobile-content__text-container">
                            <span class="mobile-content__text">
                                Thetanuts Basic
                            </span>
                        </div>
                    </router-link>

                    <AppButton
                        class="text-uppercase mobile-content__link-switch d-none"
                    >
                        Switch to V1
                    </AppButton>

                    <div class="mobile-content-list">
                        <div class="mobile-content-list__parent-menu">
                            <a
                                class="mobile-content-list__parent-menu-link"
                                href="https://docs.thetanuts.finance/"
                                target="_blank"
                            >
                                <div
                                    class="mobile-content-list__parent-menu-text"
                                >
                                    Docs
                                </div>
                            </a>
                        </div>
                        <div class="mobileNav__community-2">
                            <div>
                                <a
                                    href="https://twitter.com/ThetanutsFi"
                                    target="_blank"
                                >
                                    <img
                                        src="/images/icon-twitter-white.svg"
                                        alt="twitter"
                                    />
                                </a>
                            </div>
                            <div>
                                <a
                                    href="https://thetanutsfinance.medium.com/"
                                    target="_blank"
                                >
                                    <img
                                        src="/images/icon-medium-white.svg"
                                        alt="medium"
                                    />
                                </a>
                            </div>
                            <div>
                                <a
                                    href="https://dsc.gg/thetanuts"
                                    target="_blank"
                                >
                                    <img
                                        src="/images/icon-discord-white.svg"
                                        alt="discord"
                                    />
                                </a>
                            </div>
                            <div>
                                <a
                                    href="https://thetanuts.substack.com"
                                    target="_blank"
                                >
                                    <img
                                        src="/images/icon-substack-white.svg"
                                        alt="substack"
                                    />
                                </a>
                            </div>
                        </div>
                        <div class="mobile-content-list__parent-menu d-none">
                            <a
                                class="mobile-content-list__parent-menu-link"
                                href="#"
                            >
                                <div
                                    class="mobile-content-list__parent-menu-text"
                                >
                                    Community
                                </div>
                            </a>
                            <a
                                class="mobile-content-list__parent-menu-link"
                                href="https://twitter.com/ThetanutsFi"
                                target="_blank"
                            >
                                <div
                                    class="mobile-content-list__parent-menu-subtext"
                                >
                                    Twitter
                                </div>
                            </a>
                            <a
                                class="mobile-content-list__parent-menu-link"
                                href="https://thetanutsfinance.medium.com/"
                                target="_blank"
                            >
                                <div
                                    class="mobile-content-list__parent-menu-subtext"
                                >
                                    Medium
                                </div>
                            </a>
                            <a
                                class="mobile-content-list__parent-menu-link"
                                href="https://dsc.gg/thetanuts"
                                target="_blank"
                            >
                                <div
                                    class="mobile-content-list__parent-menu-subtext"
                                >
                                    Discord
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </b-navbar-brand>

            <!-- Desktop -->
            <b-navbar-nav
                class="ml-auto align-top"
                id="list-menu-desktop"
                style="min-width: 148px; justify-content: flex-end;"
            >
                <b-navbar-nav class="nav-head-right">
                    <template>
                        <b-nav-item
                            class="nav-item-vault"
                            link-classes="no-focus-color"
                        >
                            <router-link
                                to="/basic/vaults"
                                active-class="header-activ"
                            >
                                <div class="btn-menu my-auto">
                                    vaults
                                </div>
                            </router-link>
                        </b-nav-item>
                        <b-nav-text
                            class="nav-item-docs btn-menu position-relative"
                        >
                            <div
                                class="btn-menu my-auto d-flex nav-item-docs-dropdown-parent"
                            >
                                Community
                                <img
                                    src="/images/landing-page/icon-caret-down-white.svg"
                                    alt="icon dropdown"
                                    class="ms-1"
                                />
                            </div>
                            <div class="nav-item-docs-dropdown">
                                <div class="nav-item-docs-dropdown__container">
                                    <div class="nav-item-docs-dropdown__item">
                                        <a
                                            class="no-focus-color"
                                            href="https://twitter.com/ThetanutsFi"
                                            target="_blank"
                                        >
                                            Twitter
                                        </a>
                                    </div>
                                    <div class="nav-item-docs-dropdown__item">
                                        <a
                                            class="no-focus-color"
                                            href="https://dsc.gg/thetanuts"
                                            target="_blank"
                                        >
                                            Discord
                                        </a>
                                    </div>
                                    <div class="nav-item-docs-dropdown__item">
                                        <a
                                            class="no-focus-color"
                                            href="https://thetanutsfinance.medium.com/"
                                            target="_blank"
                                        >
                                            Medium
                                        </a>
                                    </div>
                                    <div class="nav-item-docs-dropdown__item">
                                        <a
                                            class="no-focus-color"
                                            href="https://thetanuts.substack.com"
                                            target="_blank"
                                        >
                                            Substack
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </b-nav-text>
                        <b-nav-item
                            class="nav-item-docs btn-menu"
                            href="https://docs.thetanuts.finance/"
                            target="_blank"
                            link-classes="no-focus-color"
                        >
                            <div class="btn-menu my-auto">
                                Docs
                            </div>
                        </b-nav-item>
                        <b-nav-item
                            class="nav-item-docs btn-menu"
                            href="https://stronghold.thetanuts.finance/"
                            target="_blank"
                            link-classes="no-focus-color"
                        >
                            <AppButton
                                class="text-uppercase mobile-content__link-switch text-uppercase mobile-content__link-switch--desktop"
                            >
                                Thetanuts Stronghold
                            </AppButton>
                        </b-nav-item>
                        <b-nav-item
                            class="nav-item-network btn-menu"
                            link-classes="no-focus-color"
                        >
                            <div class="btn-menu my-auto">
                                <div
                                    class="mobile-network-wallet__btn-container mobile-network-wallet__btn--desktop"
                                >
                                    <network-connect></network-connect>
                                </div>
                            </div>
                        </b-nav-item>
                        <b-nav-item
                            class="nav-item-connect btn-menu"
                            link-classes="no-focus-color"
                        >
                            <div class="btn-menu my-auto">
                                <div
                                    class="mobile-network-wallet__btn-container mobile-network-wallet__btn--desktop"
                                >
                                    <wallet-connect></wallet-connect>
                                </div>
                            </div>
                        </b-nav-item>
                    </template>
                </b-navbar-nav>
            </b-navbar-nav>
        </b-navbar>

        <div class="mobile-network-wallet">
            <div class="mobile-network-wallet__btn-container">
                <NetworkConnect />
            </div>
            <div class="mobile-network-wallet__btn-container">
                <WalletConnect />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import NetworkConnect from "../Wallet/Network.vue";
import WalletConnect from "../Wallet/Connect.vue";
import AppButton from "../LandingPage/AppButton.vue";

export default {
    components: {
        NetworkConnect,
        WalletConnect,
        AppButton
    },
    data() {
        return {
            isMenuActive: false,
            scrolldata: null
        };
    },
    computed: {
        ...mapGetters({
            hasWallet: "wallet/getHasWallet",
            selectedNetwork: "wallet/getSelectedNetwork",
            getAvailableNetwork: "vaults/getAvailableNetwork"
        }),
        iconMenu() {
            return this.isMenuActive
                ? "/images/header/icon-close.svg"
                : "/images/header/icon-menu.svg";
        }
    },
    methods: {
        updateScroll() {
            this.scrolldata = window.scrollY;
        }
    },
    mounted() {
        window.addEventListener("scroll", this.updateScroll);

        const menuBtn = document.querySelector(".nav-item-burger-icon");
        const mobileContent = document.querySelector(".mobile-content");

        menuBtn.addEventListener("click", () => {
            if (this.isMenuActive) {
                mobileContent.classList.remove("mobile-content--hide");
            }
            setTimeout(() => {
                mobileContent.classList.toggle("mobile-content--active");
            }, 50);
        });

        mobileContent.addEventListener("transitionend", () => {
            if (!this.isMenuActive) {
                mobileContent.classList.add("mobile-content--hide");
            }
        });
    }
};
</script>

<style lang="scss" scoped>
.header-nav {
    padding-right: 60px;

    @media only screen and (min-width: 1920px) {
        padding-right: 3.125vw;
    }
}

.mobile-nav-bg {
    background-color: #111213 !important;

    @media only screen and (min-width: 768px) {
        background-color: transparent !important;
    }

    &.bg_scroll {
        background-color: rgb(20, 21, 21) !important;
    }
}
.mobileNav__community-2 {
    display: flex;
    align-items: center;
    gap: 40px;
    margin-top: 30px;
}

.mobile-img__container {
    display: flex;

    .mobile-img__wrapper {
        display: flex;
        width: 162px;
        height: 20px;

        @media only screen and (min-width: 1440px) {
            width: 11.25vw;
            height: 1.3888888888888888vw;
        }

        img {
            width: 100%;
            height: 100%;
            transition: all 0.3s ease;

            &:hover {
                filter: drop-shadow(0 0 15px #1ae899);
            }
        }
    }
}
.nav-item-burger-icon {
    margin-left: auto;
    display: flex;

    @media only screen and (min-width: 768px) {
        display: none;
    }
}
#list-menu-desktop {
    display: none;

    @media only screen and (min-width: 768px) {
        display: inline-block;
    }
}
.mobile-content {
    position: fixed;
    top: 60px;
    left: 0;
    width: 100%;
    height: calc(100% - 60px);
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 10;
    transition: opacity 0.5s ease;
    opacity: 0;
    padding: 35px;
    color: #fff;
    display: flex;
    flex-direction: column;

    &.mobile-content--active {
        opacity: 1;
    }

    &.mobile-content--hide {
        display: none;
    }

    .mobile-content__text-container {
        margin-bottom: 90px;

        .mobile-content__text {
            font-family: Sofia Sans;
            font-size: 30px;
            font-style: normal;
            font-weight: 700;
            line-height: 36px;
            letter-spacing: 0em;

            background-image: linear-gradient(
                95.12deg,
                #1cc8c1 0%,
                #05feb1 0.01%,
                #d9ef46 28.64%,
                #ff843f 49.48%,
                #a2f9e4 73.96%,
                #05feb1 100%
            );
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;

            background-size: 300%;
            background-position: -100%;

            animation: animatedText 5s infinite alternate-reverse;
        }
    }

    .mobile-content-list {
        // margin-top: auto;

        .mobile-content-list__parent-menu {
            .mobile-content-list__parent-menu-link {
                color: #fff;
                margin-top: 15px;

                .mobile-content-list__parent-menu-text {
                    font-family: Sofia Sans;
                    font-size: 26px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 42px;
                    letter-spacing: 0px;
                    margin-top: 15px;
                    text-transform: uppercase;
                }
                .mobile-content-list__parent-menu-subtext {
                    font-family: Sofia Sans;
                    font-size: 22px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 22px;
                    letter-spacing: 0px;
                    margin-top: 10px;
                    text-transform: uppercase;
                }
            }
        }
    }
}

.mobile-network-wallet {
    color: #fff;
    padding: 15px 20px;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;

    @media only screen and (min-width: 768px) {
        display: none;
    }
}

.mobile-content__link-switch {
    margin-top: 90px;

    @media only screen and (min-width: 768px) {
        margin-top: 0;
    }

    ::v-deep button {
        padding: 5px 20px;
    }

    &.mobile-content__link-switch--desktop {
        // width: 180px;

        @media only screen and (min-width: 1440px) {
            // width: 12.5vw;
        }

        ::v-deep button {
            text-transform: none;
            font-family: Sofia Sans;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: 22px;
            letter-spacing: 0em;
            text-align: center;
            padding: 6px 17px;

            @media only screen and (min-width: 1920px) {
                font-size: 0.9375vw;
                line-height: 1.1458333333333333vw;
                padding: 0.3125vw 0.8854166666666666vw;
            }
        }
    }
}

::v-deep .mobile-network-wallet__btn-container {
    width: 100%;
    position: relative;

    &.mobile-network-wallet__btn--desktop {
        width: 170px;

        @media only screen and (min-width: 1920px) {
            width: 8.854166666666666vw;
        }

        .mobile-network-wallet__btn {
            padding: 10px 15px;

            @media only screen and (min-width: 1920px) {
                padding: 0.5208333333333334vw 0.5208333333333334vw;
            }

            span {
                display: flex;
                justify-content: space-between;

                &.selected-network {
                    justify-content: center;
                    align-items: center;
                }
            }
        }
    }

    .mobile-network-wallet__btn {
        font-family: Sofia Sans;
        font-size: 13px;
        font-style: normal;
        font-weight: 700;
        line-height: 13px;
        letter-spacing: 0px;
        border: 0.704301px solid #ffffff;
        border-radius: 4.22581px;
        width: 100%;
        text-align: center;
        padding: 7px 10px;
        cursor: pointer;
        text-transform: capitalize;

        &:hover {
            opacity: 0.8;
            color: #00ff3d;
        }

        @media only screen and (min-width: 1440px) {
            font-size: 0.9027777777777778vw;
            line-height: 0.9027777777777778vw;
            border: 0.06944444444444445vw solid #ffffff;
            border-radius: 0.3472222222222222vw;
        }

        img {
            margin-left: 5px;
            width: 11px;

            @media only screen and (min-width: 1440px) {
                margin-left: 0.3472222222222222vw;
                width: 0.7638888888888888vw;
            }
        }

        span {
            display: flex;
            justify-content: center;
            text-transform: capitalize;

            &.selected-network {
                text-transform: uppercase;
            }
        }

        &.mobile-network-wallet__btn--connected {
            border-color: #00ff3d;
        }
    }

    .mobile-network-wallet__dropdown {
        position: absolute;
        width: 100%;
        background-color: #283841;
        padding: 10px 20px;
        border-radius: 5px;
        top: 99%;
        display: none;
        max-height: 200px;
        height: auto;
        overflow-y: auto;

        /* Scrollbar */

        /* width */
        &::-webkit-scrollbar {
            width: 10px;
            margin-left: 10px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
            // background: #f1f1f1;
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
            background: rgba(136, 136, 136, 0.521);
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
            background: rgba(83, 81, 81, 0.459);
        }

        @media only screen and (min-width: 1920px) {
            padding: 0.5208333333333334vw 1.0416666666666667vw;
            border-radius: 0.2604166666666667vw;
            max-height: 10.416666666666666vw;
        }

        &.mobile-network-wallet--active {
            display: block;
        }

        .mobile-network-wallet__dropdown-list {
            display: flex;
            align-items: center;
            cursor: pointer;
            color: #fff;

            &:hover {
                opacity: 0.8;
                color: #00ff3d;
            }

            &:not(:last-child) {
                margin-bottom: 25px;

                @media only screen and (min-width: 1440px) {
                    margin-bottom: 1.7361111111111112vw;
                }
            }

            .mobile-network-wallet__list-img {
                width: 24px;
                height: 24px;
                margin-right: 15px;

                @media only screen and (min-width: 1920px) {
                    width: 1.25vw;
                    height: 1.25vw;
                    margin-right: 0.78125vw;
                }

                img {
                    height: 100%;
                }
            }
            span {
                font-family: Roboto;
                font-size: 13px;
                font-style: normal;
                font-weight: 400;
                line-height: 19px;
                letter-spacing: 0em;
                text-align: left;
                text-transform: uppercase;

                @media only screen and (min-width: 1440px) {
                    // font-size: 1.1111111111111112vw;
                    font-size: 0.9027777777777778vw;
                    line-height: 1.3194444444444444vw;
                }
            }
        }
    }
}
.w-100-mobile-only {
    width: 100%;

    @media only screen and (min-width: 768px) {
        width: auto;
    }
}
.ms-1 {
    margin-left: 5px;
    width: 14px;
    height: 14px;

    @media only screen and (min-width: 1440px) {
        margin-left: 0.3472222222222222vw;
        width: 0.9722222222222222vw;
        height: 0.9722222222222222vw;
    }
}
.nav-item-docs-dropdown-parent {
    align-items: center;
    color: #fff;
    cursor: pointer;

    &:hover {
        color: #4ec575;

        ~ .nav-item-docs-dropdown {
            display: block;
        }
    }

    ~ .nav-item-docs-dropdown {
        position: absolute;
        top: 100%;
        padding: 10px 0;
        display: none;

        @media only screen and (min-width: 1440px) {
            padding: 0.6944444444444444vw 0;
        }

        &:hover {
            display: block;
        }

        .nav-item-docs-dropdown__container {
            background-color: #283841;
            padding: 10px 15px;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            border-radius: 5px;
            gap: 15px;

            @media only screen and (min-width: 1440px) {
                padding: 0.6944444444444444vw 1.0416666666666667vw;
                // width: 8.680555555555555vw;
                border-radius: 0.3472222222222222vw;
                gap: 1.0416666666666667vw;
            }
        }

        .nav-item-docs-dropdown__item {
            font-family: Sofia Sans;
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 32px;
            letter-spacing: 0px;
            text-align: left;
            color: #fff;

            @media only screen and (min-width: 1440px) {
                font-size: 1.25vw;
                line-height: 2.2222222222222223vw;
            }

            &:hover {
                color: #4ec575;
            }
        }
    }
}
.no-focus-color {
    &:focus {
        color: #fff !important;
    }
}
.navbar-nav.nav-head-right {
    gap: 0 !important;

    li {
        min-width: auto;
        padding: 0;
        margin: auto 16px !important;

        @media only screen and (min-width: 1920px) {
            margin: auto 0.8333333333333334vw !important;
        }
    }
}
</style>
